import type { LocationsListTableRowActionsProps } from "./locations-list-table-row-actions.type";

import ListTableRowActions from "@/modules/list-table-row-actions";

import LocationsListTableRowActions from "./locations-list-table-row-actions.component";

const locationsListTableRowActionsWrapper = (
  props: LocationsListTableRowActionsProps
) => {
  return (
    <ListTableRowActions modelKey="location" modelId={props.location.id}>
      <LocationsListTableRowActions {...props} />
    </ListTableRowActions>
  );
};

export default locationsListTableRowActionsWrapper;
